import { Moment } from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DateFromTo } from 'components/atoms/date-from-to';
import { DueDate } from 'components/atoms/due-date';
import { status, DueDateStatus } from 'components/atoms/due-date/status';
import { TaskDurationPropTypes } from './task-duration.types';

const Wrapper = styled.span`
  color: var(--gray-70);
  font-size: var(--font-size-sm);
`;

export const TaskDuration = ({ startDate, dueDate }: TaskDurationPropTypes) => {
  const dateStatus = status(dueDate as Moment);

  if (dueDate?.isValid()) {
    switch (dateStatus) {
      case DueDateStatus.Overdue: {
        return (
          <Wrapper>
            <DueDate timestamp={dueDate} />
          </Wrapper>
        );
      }

      case DueDateStatus.Attention: {
        return (
          <Wrapper>
            <DueDate timestamp={dueDate} />
          </Wrapper>
        );
      }

      case DueDateStatus.Default:
      default: {
        return (
          <Wrapper>
            <DateFromTo from={startDate} to={dueDate} />
          </Wrapper>
        );
      }
    }
  }

  return null;
};
